/* eslint-disable camelcase */
import _ from 'lodash';

class ServerCall implements MerchantosServerCall {
  use_iframe: boolean;

  constructor() {
    this.use_iframe = false;
  }

  bind = (
    data: ServerCallData,
    callback?: DoServerCallCallback,
    noError?: boolean,
    doAsPost?: boolean,
    isRetry?: boolean
  ) => {
    const ajax_url = `/ajax_forms.php?ajax=1&no_cache=${new Date().getTime()}`;

    // prevent repeat actions without a server response
    const prevent_repeat_id = window.merchantos.controls.prevent_repeat.attachToServerCall();

    if (data.form_name !== 'timeout_check') {
      window.merchantos.notifier.startWarningTimeout();
      window.merchantos.notifier.startAlertTimeout();
    }

    const type = window.getRequestType(data);

    window.showNotifier('working');

    // @ts-expect-error ts-migrate(7022) FIXME: 'promise' implicitly has type 'any' because it doe... Remove this comment to see the full error message
    const promise = $.ajax({
      url: ajax_url,
      mimeType: 'text/json',
      type,
      data,
    })
      // eslint-disable-next-line consistent-return
      .done((data, _textStatus, _jqXHR) => {
        inFlightPanelXhrRequest = null;

        // free up the callee button/action
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | boolean' is not assigna... Remove this comment to see the full error message
        window.merchantos.controls.prevent_repeat.freeIt(prevent_repeat_id);

        window.resetIdleTimer();
        // make sure data is there
        if (!data) {
          window.alertUser('Could not complete request. If this continues contact support.');
          return promise;
        }
        if (window.merchantos.server_call.result(data)) {
          window.merchantos.interrupt.empty(data.form_name);
          return promise;
        }
        // Make sure we were passed a callback_fnc to call.
        if (_.isFunction(callback)) {
          callback(data);
        }
        window.merchantos.datepicker.init();
        window.merchantos.interrupt.process(data.form_name);
        window.numberScrollInputFix();
        window.autosizeLoader();
      })
      // eslint-disable-next-line consistent-return
      .fail((jqXHR, textStatus, errorThrown) => {
        window.merchantos.controls.prevent_repeat.freeAll();
        // Prevent error logging from throwing error (loop insanity)
        if (noError) {
          return promise;
        }
        // If we get a failed call that has no error, retry once immediately
        if (!errorThrown && !isRetry) {
          // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'ContentMap' is not assignable to... Remove this comment to see the full error message
          window.merchantos.server_call.log_dropped_request(data, type, textStatus, jqXHR);
          if (data.form_name === 'register.add_item_search') {
            window.location.reload();
          } else if (type === 'GET') {
            // @ts-expect-error ts-migrate(2554) FIXME: Expected 1-4 arguments, but got 5.
            window.merchantos.server_call.bind(data, callback, noError, doAsPost, true);
          }
          return promise;
        }
        if (errorThrown && typeof errorThrown === 'string') {
          if (errorThrown.match(/Invalid JSON/)) {
            if (jqXHR.responseText) {
              // eslint-disable-next-line no-param-reassign
              errorThrown = jqXHR.responseText;
            }
          }
        }
        if (data) {
          if (data.pannel_id) {
            // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'JQuery<HTMLElement>' is not assi... Remove this comment to see the full error message
            window.clearWorking($(`#${data.pannel_id}`));
          }
          if (data.form_name) {
            window.merchantos.interrupt.process(data.form_name);
          }
        }

        if (jqXHR.statusText !== 'abort') {
          const defaultAlert =
            'Unable to contact server. You may be having a problem with your internet connection. If this continues contact support';
          if (typeof jqXHR.responseText !== 'undefined') {
            let jsonData;
            try {
              jsonData = JSON.parse(jqXHR.responseText);
            } finally {
              if (jsonData && jsonData.error && typeof jsonData.error === 'string') {
                window.alertUser(jsonData.error);
              } else {
                window.alertUser(defaultAlert);
              }
            }
          } else {
            window.alertUser(defaultAlert);
          }
        }
      })
      .always(() => window.hideNotifier('working'));
    window.merchantos.asyncSubscribe.notifySubscribers(data.form_name, data, promise);
    return promise;
  };

  result = (data: AjaxFormsResponse) => {
    let delay;
    if (!window || window.closing) return true;

    if (data.goto_url) {
      window.merchantos.utils.openUrl(data.goto_url);
      return true;
    }

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'post_vars' does not exist on type 'Parti... Remove this comment to see the full error message
    if (data.post_to_url && data.post_vars) {
      // write a form at the bottom of the body and put the post vars in there and then submit() the form
      const form = document.createElement('form');
      form.method = 'post';
      form.action = data.post_to_url;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'post_vars' does not exist on type 'Parti... Remove this comment to see the full error message
      // eslint-disable-next-line
      for (const post_field in data.post_vars) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = post_field;
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'post_vars' does not exist on type 'Parti... Remove this comment to see the full error message
        input.value = data.post_vars[post_field];
        form.appendChild(input);
      }
      document.body.appendChild(form);
      form.submit();
      return true;
    }

    // TODO: safe to rely only on data.logout_url; fallback on data.logout is
    // only included for release/rollback compatibility
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'logout' does not exist on type 'Partial<... Remove this comment to see the full error message
    if (data.logout || data.logout_url) {
      let logout_url = '/register.php';
      // @ts-expect-error ts-migrate(2551) FIXME: Property 'logout_url' does not exist on type 'Part... Remove this comment to see the full error message
      if (data.logout_url) {
        // @ts-expect-error ts-migrate(2551) FIXME: Property 'logout_url' does not exist on type 'Part... Remove this comment to see the full error message
        logout_url = data.logout_url;
      }
      window.merchantos.utils.openUrl(logout_url);
      return true;
    }

    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'Partial<{ name: string; title: s... Remove this comment to see the full error message
    if (window.merchantos.register.isRegisterRuleAgeVerificationError(data)) {
      return true;
    }

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'error' does not exist on type 'Partial<{... Remove this comment to see the full error message
    if (data.error) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'error' does not exist on type 'Partial<{... Remove this comment to see the full error message
      window.alertUser(data.error);
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'PanelId | undefined' is not assi... Remove this comment to see the full error message
      window.clearRequestQueue(data.pannel_id);
      return true;
    }

    if (data.debug) {
      window.addDebug(data.debug);
    }

    if (data.failed_msg) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'length' does not exist on type 'string |... Remove this comment to see the full error message
      delay = Math.ceil((data.failed_msg.length + 1) / 8);
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | true' is not assignable... Remove this comment to see the full error message
      window.flashNotifier('warning', data.failed_msg, delay);
    }

    if (data.success_msg) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'length' does not exist on type 'string |... Remove this comment to see the full error message
      delay = Math.ceil((data.success_msg.length + 1) / 8);
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | true' is not assignable... Remove this comment to see the full error message
      window.flashNotifier('success', data.success_msg, delay);
    }

    if (data.alert_msg) {
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | true' is not assignable... Remove this comment to see the full error message
      window.showNotifier('messages', data.alert_msg);
    }

    if (data.evalcode) {
      // eslint-disable-next-line no-eval
      eval(data.evalcode);
    }

    if (data.need_access_pin) {
      if (data.html) {
        window.no_page_timeouts = true;
        const verify_node = $('#verify_pin');
        if (verify_node.length === 0) {
          window.cb_switch_employees(data);
        }
      } else {
        window.merchantos.utils.openUrl('/register.php');
      }
      return true;
    }

    if (data.add_html) {
      $('body').append(data.add_html);
    }

    return false;
  };

  log_dropped_request = (
    data: AjaxFormsResponse,
    type: 'POST' | 'GET',
    textStatus: JQuery.Ajax.ErrorTextStatus,
    jqXHR: JQuery.jqXHR<any>
  ) => {
    let xml = '<DroppedRequest>';
    xml += `<name>${data.name || data.form_name}</name>`;
    xml += `<httpMethod>${type}</httpMethod>`;
    xml += `<failureReason> ${textStatus}</failureReason>`;

    if (typeof jqXHR !== typeof undefined && typeof jqXHR.getAllResponseHeaders === 'function') {
      xml += `<responseHeaders>${jqXHR.getAllResponseHeaders()}</responseHeaders>`;
    }

    xml += '</DroppedRequest>';

    return window.lsCloud.startServerJob({
      type: 'POST',
      url: '/API/DroppedRequest',
      data: xml,
    });
  };
}

window.merchantos.server_call = new ServerCall();

window.idleTimeout = function idleTimeout() {
  if (window.no_page_timeouts || window.isGriffin()) return;
  const content_map = {} as ContentMap;
  content_map.form_name = 'timeout_check';

  window.merchantos.server_call.bind(content_map, window.resetIdleTimer, true);
};

window.resetIdleTimer = function resetIdleTimer() {
  if (window.idle_timer) {
    window.clearTimeout(window.idle_timer);
  }

  if (window.timeout_delay) {
    window.idle_timer = window.setTimeout(
      window.idleTimeout,
      window.timeout_delay * 60 * 1000 + 5000
    );
  }
};

// @Note Legacy way of finding out the request type to send,
// A way to improve this would be so the BE passes the type in the payload
window.getRequestType = function getRequestType(data) {
  return (data as ContentMap).fnc === 'save' || JSON.stringify(data).length >= 1800
    ? 'POST'
    : 'GET';
};

// If the panel_id is defined, the screens are changing
let inFlightPanelXhrRequest: TSFixMe = null;

window.doServerCall = function doServerCall(data, callback_fnc, no_error, do_as_post) {
  const phoenixRoute = window.Ashes.createRoute(data);
  let isPanelXhrRequest = false;
  let returnedPromise = null;
  const requestType = window.getRequestType(data);

  if (phoenixRoute && phoenixRoute.route) {
    window.merchantos.utils.openUrl(phoenixRoute.route);
    returnedPromise = $.Deferred()
      .resolve()
      .promise();
  } else {
    // All of gui_def navigation goes to server_call. When a section, a listing or a view is required
    // or saved, a doServerCall is sent. A frequent error that happens during user's navigation
    // is that they fast click a couple links and get the wrong tab / view is then showing.
    // This is due to the last received GET request replacing the content, but it doesn't mean
    // that the last clicked link is the last received request (in case of a request taking longer
    // than the other). To solve this issue any previous request that was made is aborted to only
    // consider the last click. ONLY for GET requests, POSTS or any other type should not get aborted.
    // More info: https://github.com/merchantos/webPOS/pull/10355/#discussion_r187359188
    if (requestType === 'GET' && data.form_name && /\.(?:open|gettab)$/.test(data.form_name)) {
      if (inFlightPanelXhrRequest) {
        inFlightPanelXhrRequest.abort();
      }
      isPanelXhrRequest = true;
    }
    returnedPromise = window.merchantos.server_call.bind(data, callback_fnc, no_error, do_as_post);
    if (isPanelXhrRequest) {
      inFlightPanelXhrRequest = returnedPromise;
    }
  }
  return returnedPromise;
};
